import { useMutation } from "@tanstack/react-query";
import { createFreeUser } from "../queries/fetchAuth";

const useCreateUser = () => {
  const { mutate, isPending } = useMutation({
    mutationKey: ['create-user'],
    mutationFn: createFreeUser,
  });

  return {
    mutate,
    isPending,
  };
};

export default useCreateUser;
